module.exports = __webpack_public_path__ + "img/trade-img3.a9e46462.png";